import src from "IMAGE";
export default { src, width: 771, height: 324, blurWidth: 8, blurHeight: 3, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAADCAYAAACuyE5IAAAAQklEQVR42k2MOQ4AIQwDc7IJ2ooe+P8vMQUIS1MkPoggZhZgIlLMLFS10Cs8amZ2MCNiuHvbpRvYB5oVxo+VD/gJLET3AXCwhP9/AAAAAElFTkSuQmCC"};
